module.exports = __webpack_public_path__ + "img/1558612384.94259056.jpg";